module.exports = __webpack_public_path__ + "img/team-insights-custom-reports-filter.4259a7e4.png";